import React, { useState } from "react";
// import "./LoanApprovalDashboard.css";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonTabs from "../../../Components/ButtonTabs/ButtonTabs";

import AllRequests from "../AllRequests";
import PendingRequests from "../PendingRequests";
import AgreementRequests from "../AgreementRequests";
import { CustomTabPanel, a11yProps, } from "../../../Helpers/CustomTabPanel/CustomTabPanel";

import { StyledBadge } from "../../RegistrationRequest/RegistrationRequest";
import InputForm from "../../../Components/InputForm/InputForm";
import AllRequestsFilters from "../Filters/AllRequestsFilters";
import LoanApprovalGrid from "../Grid/LoanApprovalGrid";
import { LoanDashboardModules } from "../../../Helpers/Enums/LoanDashboardModules";
import { ITab } from "../Interfaces/ITab";
import { LoanDashboardEventTarget } from "../Enums/LoanDashboardEventTarget";
import { ILoanApprovalFilters } from "../Grid/ILoanApprovalGrid";
import { Tooltip } from "@mui/material";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import { ExportToExcel } from "../Helpers/GridHelper";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { getContext } from "../../../Helpers/Context/Context";
import { useNavigate } from "react-router-dom";

const LoanSettlement = () => {
  const navigate = useNavigate();
  const context = getContext();
  const [tabAllCount, setTabAllCount] = useState(0);
  const [tabClickValue, setTabClickValue] = useState("All-Request-tab");
  const [tabPendingCount, setTabPendingCount] = useState(0);
  const [dashboardFilterOn, setDashboardFilterOn] = useState<boolean>(false);
  const [isAllRequestSelected, setIsAllRequestSelected] =
    useState<boolean>(true);
    const [tabClickAPIcall, setTabClickAPIcall] = useState({ AllRequest: true, PendingRequest: false,});
    const [tabClickClass, setTabClickClass] = useState({
      AllRequest: "tab-pane fade  active show",
      PendingRequest: "tab-pane fade",
    });

  const [value, setValue] = React.useState(0);
  const [searchText, setSearchText] = useState("");
  // const [dashboardFilterOn, setDashboardFilterOn] = useState<boolean>(false);
  const [currentFilters, setCurrentFilters] =
    useState<ILoanApprovalFilters>(null);
  const [dataCount, setDataCount] = useState(0);
  const [currentDataReqObj, setCurrentDataReqObj] = useState(null);

  const [tabs, setTabs] = useState<ITab[]>([
    {
      label: "Requests1 ",
      value: { ...a11yProps(0) },
      count: 0,
      active: true,
      visible: true,
      id: "all-requests",
      target: LoanDashboardEventTarget.TabAllRequestsClick,
      module: LoanDashboardModules.All,
    },
    {
      label: "Pending Requests ",
      value: { ...a11yProps(1) },
      count: 0,
      active: false,
      visible: context?.CurrentRoleId === RoleEnum.InternalTeam,
      id: "pending-requests",
      target: LoanDashboardEventTarget.TabApprovalPendingClick,
      module: LoanDashboardModules.Pending,
    },

  ]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // setTabsStatus((prevStatus) => prevStatus.map((_, index) => index <= newValue));
  };


  const onTabClickAPIcall = async (param: any) => {
    // await resetFunction();
    setDashboardFilterOn(false);
    switch (param) {
      case "All-Request-tab":
        setTabClickAPIcall({
          AllRequest: true,
          PendingRequest: false,
        });
        setTabClickClass({
          AllRequest: "tab-pane fade  active show",
          PendingRequest: "tab-pane fade",
        });
        break;
      case "Pending-Request-tab":
        setTabClickAPIcall({
          AllRequest: false,
          PendingRequest: true,
        });
        setTabClickClass({
          AllRequest: "tab-pane fade",
          PendingRequest: "tab-pane fade  active show",
        });
        break;
      default:
        setTabClickAPIcall({
          AllRequest: true,
          PendingRequest: false,
        });
        setTabClickClass({
          AllRequest: "tab-pane fade  active show",
          PendingRequest: "tab-pane fade",
        });
        break;
    }
  };

  // const changeTab = (tabNum) => {
  //   const newTabs = [...tabs];
  //   newTabs.forEach((nt) => (nt.active = false));
  //   newTabs[tabNum].active = true;
  //   setTabs(newTabs);
  // };

  const onClickOftab = (event: any) => {
    setTabClickValue(event.target.id);
    onTabClickAPIcall(event.target.id);

    if (event.target.id == "All-Request-tab") {
      setIsAllRequestSelected(true);
    } else {
      setIsAllRequestSelected(false);
    }
  };

  

  // const handleEvents = (
  //   target: LoanDashboardEventTarget,
  //   event: any = null
  // ) => {
  //   switch (target) {
  //     case LoanDashboardEventTarget.TabAllRequestsClick:
  //       changeTab(0);
  //       break;
  //     case LoanDashboardEventTarget.TabApprovalPendingClick:
  //       changeTab(1);
  //       break;
  //     case LoanDashboardEventTarget.TabAgreementRequestClick:
  //       changeTab(2);
  //       break;
  //     case LoanDashboardEventTarget.TabFinalDisbursementClick:
  //       changeTab(3);
  //       break;
  //     case LoanDashboardEventTarget.FilterClick:
  //       setDashboardFilterOn(!dashboardFilterOn);
  //       break;
  //     case LoanDashboardEventTarget.SearchClick:
  //       setSearchText(event?.target?.value);
  //       break;
  //     case LoanDashboardEventTarget.ExportToExcelClick:
  //       if (dataCount === 0) {
  //         notify(ToastType.Error, "No data available");
  //       } else {
  //         //exportToExcelFunction();
  //         ExportToExcel(
  //           dataCount,
  //           currentDataReqObj.searchText,
  //           currentDataReqObj.sortColumn,
  //           currentDataReqObj.sortDirection,
  //           currentDataReqObj.MemberId,
  //           currentDataReqObj.UnitCodeId,
  //           currentDataReqObj.TypeofApplicantId,
  //           currentDataReqObj.FromDate,
  //           currentDataReqObj.ToDate,
  //           currentDataReqObj.Status,
  //           currentDataReqObj.IsApproval,
  //           currentDataReqObj.IsAgreement,
  //           currentDataReqObj.IsFinalDisbursement,
  //           context?.CurrentRoleId,
  //           context?.Id
  //         );
  //       }
  //       break;
  //   }
  // };

  const TabsComponent = ({ tab }) => {
    const { count, active, id, target, label } = tab;

    return (
      <StyledBadge
        badgeContent={count}
        color="error"
        className="mr-3"
        max={99}
        invisible={true}
      >
        <li className="nav-item" role="presentation">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            key="Dashboard"
            className={active ? "nav-link active" : "nav-link"}
            id={id}
            data-toggle="pill"
            role="tab"
            aria-controls="pills-MA"
            aria-selected={active ? "true" : "false"}
            // onClick={() => handleEvents(target)}
          >
            {label}
          </a>
        </li>
      </StyledBadge>
    );
  };

  return (
    <>
      <div className="">
        <div className="">
          <div className="clearfix"></div>
          <div className="page-content row filter-row-container m-0 no-gutters">
            <div className="transformer-tabs col-lg-12 col-md-12">
              <div className="meeting-tabs tabs-main col-lg-12 p-0">
                {/* <div className="page-content row filter-row-container mb-0 ml-0 mr-0"> */}
                <div className="col-lg-12 p-0">
                  <div className="row">
                    {/* <div className="col-lg-6 col-md-6 col-sm-12 no-gutters">
                      <nav className="tabs mr-sm-4 --jsfied">
                        <ul
                          className="nav nav-pills  float-left -primary"
                          id="pills-tab"
                          role="tablist"
                        >
                          {tabs.map((tab) => {
                            if (!tab.visible) return null;
                            return <TabsComponent tab={tab} key={tab.id} />;
                          })}
                        </ul>
                      </nav>
                    </div> */}


<div className="col-lg-5 col-md-5">
                      <nav className="tabs mr-sm-4 --jsfied">
                        <ul
                          className="nav nav-pills  float-left -primary"
                          id="pills-tab"
                          role="tablist"
                        >
                          <StyledBadge
                            badgeContent={tabAllCount}
                            color="error"
                            className="mr-3"
                            max={99}
                            invisible={true}
                          >
                            <li className="nav-item" role="presentation">
                              <a
                                key="Dashboard"
                                className={
                                  tabClickValue === "All-Request-tab"
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                id="All-Request-tab"
                                data-toggle="pill"
                                role="tab"
                                aria-controls="pills-MA"
                                aria-selected={
                                  tabClickValue === "All-Request-tab"
                                    ? "true"
                                    : "false"
                                }
                                onClick={onClickOftab}
                              >
                                My Requests
                              </a>
                            </li>
                          </StyledBadge>
                          <StyledBadge
                            badgeContent={tabPendingCount}
                            color="error"
                            className="mr-3"
                            max={99}
                            invisible={true}
                          >
                            <li className="nav-item" role="presentation">
                              <a
                                key="Dashboard"
                                className={
                                  tabClickValue === "Pending-Request-tab"
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                id="Pending-Request-tab"
                                data-toggle="pill"
                                role="tab"
                                aria-controls="pills-MA"
                                aria-selected={
                                  tabClickValue === "Pending-Request-tab"
                                    ? "true"
                                    : "false"
                                }
                                onClick={onClickOftab}
                              >
                                Pending Requests
                              </a>
                            </li>
                          </StyledBadge>
                        </ul>
                      </nav>
                    </div>
                    
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>

          <AllRequestsFilters
            activeTab={tabs.find((t) => t.active)}
            dashboardFilterOn={dashboardFilterOn}
            setCurrentFilters={setCurrentFilters}
          />

          <LoanApprovalGrid
            searchText={searchText}
            setSearchText={setSearchText}
            activeTab={tabs.find((t) => t.active)}
            currentFilters={currentFilters}
            dataCount={dataCount}
            setDataCount={setDataCount}
            setCurrentDataReqObj={setCurrentDataReqObj}
          />
        </div>
      </div>
    </>
  );
};

export default LoanSettlement;
